import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import SchurtisPhotos from './SchurtisPhotos'

ReactDOM.render(
  <BrowserRouter><SchurtisPhotos /></BrowserRouter>,
  document.getElementById('reactRoot')
)
